var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C414F",
    d: "m7.999 8.667-.43.614a.75.75 0 0 0 .86 0l-.43-.614Zm-5.334-5.25h10.667v-1.5H2.665v1.5Zm10.667 0c.32 0 .583.264.583.583h1.5a2.087 2.087 0 0 0-2.083-2.083v1.5Zm.583.583v8h1.5V4h-1.5Zm0 8c0 .32-.264.584-.583.584v1.5A2.087 2.087 0 0 0 15.415 12h-1.5Zm-.583.584H2.665v1.5h10.667v-1.5Zm-10.667 0A.587.587 0 0 1 2.082 12h-1.5c0 1.148.936 2.084 2.083 2.084v-1.5ZM2.082 12V4h-1.5v8h1.5Zm0-8c0-.319.264-.583.583-.583v-1.5A2.087 2.087 0 0 0 .582 4h1.5Zm12.153-.614L7.57 8.053l.86 1.228 6.666-4.666-.86-1.23ZM8.43 8.053 1.762 3.386l-.86 1.229L7.569 9.28l.86-1.228Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.8386cde7.svg";
export { ForwardRef as ReactComponent };